// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__VATKa","btn":"NotFound_btn__nrDwG"};